import './index.scss';
import { useEffect } from 'react';
import CancellationPolicyInfo from './CancellationPolicyInfo';
import {
  useFetchPolicy,
  usePolicyManagementPolicy,
} from '../../../../store/PolicyManagement/policyManagementHooks';

type Props = {
  policyId: number;
};

const CancellationPolicyContainer = ({ policyId }: Props) => {
  const fetchPolicy = useFetchPolicy();
  const policy = usePolicyManagementPolicy();

  useEffect(() => {
    if (policy.id !== policyId) {
      fetchPolicy(policyId).finally();
    }
  }, [policyId]);

  return <CancellationPolicyInfo policy={policy} />;
};

export default CancellationPolicyContainer;
